module.exports = __webpack_public_path__ + "img/reference61.7c7b4138.jpg";